import Link from "next/link";
import React, { useState } from "react";
import styles from "./Transformative.module.css";
import { ChevronRight, ChevronDown, ArrowRight } from "lucide-react";

interface TitleDescription {
  id: number;
  title: string;
  description: string;
}

interface Link {
  id: number;
  label: string;
  url: string;
}

interface ProgrammeData {
  id: number;
  title_description: TitleDescription;
  link: Link;
}

interface TransformativeLearningProps {
  className?: string;
  data: ProgrammeData[];
}

const TransformativeLearning: React.FC<TransformativeLearningProps> = ({
  data,
  className,
}) => {
  const [activeAccordion, setActiveAccordion] = useState<number | null>(null);

  const handleAccordionClick = (id: number) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };
  return (
    <div className={className ? styles.aboutTransformative : ""}>
      <div className="container">
        <div className={styles.TransformativeLearning}>
          {data?.[0]?.title_description?.title && (
            <h2 className={styles.mobItem}>
              {data[0].title_description.title || ""}
            </h2>
          )}
          {data?.[0]?.title_description?.description && (
            <p className={styles.mobItem}>
              {data?.[0]?.title_description?.description || ""}
            </p>
          )}

          {/* Desktop View */}
          <div className="row d-none d-md-flex justify-content-center">
            {data?.map((programme: ProgrammeData) => (
              <div
                key={programme.id}
                className={`col-md-6 col-xl-3  mb-4 ${styles.programBox}`}
              >
                <div className={styles.card}>
                  <strong>{programme?.title_description?.title}</strong>
                  <span>{programme?.title_description?.description}</span>

                  <Link
                    title={programme?.link?.label}
                    href={programme?.link?.url}
                    target="_blank"
                    className={styles.link}
                  >
                    {programme?.link?.label} <ArrowRight />
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile Accordion View */}
          <div className="d-md-none">
            <div className="accordion" id="accordionExample">
              {data?.map((programme: ProgrammeData, index: number) => (
                <div className="accordion-item" key={programme.id}>
                  <h3
                    className="accordion-header"
                    id={`heading${programme.id}`}
                  >
                    <button
                      className={`accordion-button ${
                        index === data.length - 1 ? "last-button" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${programme.id}`}
                      aria-expanded={activeAccordion === programme.id}
                      aria-controls={`collapse${programme.id}`}
                      onClick={() => handleAccordionClick(programme.id)}
                    >
                      <strong>{programme.title_description.title}</strong>
                      <span className={`${styles.accordionIcon} ms-auto`}>
                        {activeAccordion === programme.id ? (
                          <ChevronDown />
                        ) : (
                          <ChevronRight />
                        )}
                      </span>
                    </button>
                  </h3>
                  <div
                    id={`collapse${programme.id}`}
                    className={`accordion-collapse collapse ${
                      activeAccordion === programme.id ? "show" : ""
                    }`}
                    aria-labelledby={`heading${programme.id}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>{programme?.title_description?.description}</p>
                      <Link
                        title={programme?.link.label}
                        href={programme?.link?.url}
                        target="_blank"
                        className={styles.link}
                      >
                        {programme?.link.label}
                        <ArrowRight />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransformativeLearning;
